import * as React from "react";
import * as React44ms from "../../Util/form-utils/react-44ms";

import { useDeliveryDetailsUserExperience } from "../providers";

import { DeliveryDetailsForm } from "../model";

import { IsBillingAndShippingTheSameFormLogic } from "../forms";

import { DeliveryDetailsActions } from "./delivery-details-actions";
import { DeliveryDetailsFormAutoScrolling } from "./delivery-details-form-auto-scrolling";
import { Billing } from "./delivery-details-billing";
import { DeliveryAddress } from "./delivery-address";
import { ShippingMethod } from "./delivery-details-shipping-method";
import { RewardsCallout } from "./delivery-details-rewards-callout";
import { DeliveryDetailsEmailConfirmation } from "./delivery-details-email-confirmation";

export interface DeliveryDetailsProps {
  formRef: React44ms.Api.TypedRef<DeliveryDetailsForm>;
}
export const DeliveryDetails: React.FunctionComponent<DeliveryDetailsProps> = (
  props
) => {
  const { deliveryFormPresentable } = useDeliveryDetailsUserExperience();

  const [_formState, locate] = React44ms.React.useForm(props.formRef);

  if (!deliveryFormPresentable) {
    return null;
  }

  return (
    <form className="delivery-details">
      <RewardsCallout />

      <DeliveryDetailsEmailConfirmation
        formRef={locate.shippingEmailConfirmation.typedRef}
      />

      <IsBillingAndShippingTheSameFormLogic
        ref={locate.isBillingAndShippingTheSame.typedRef}
      />

      <DeliveryAddress
        formRef={locate.shipping.typedRef}
        formRef_isBillingAndShippingTheSame={
          locate.isBillingAndShippingTheSame.typedRef
        }
      />

      <Billing
        formRef={locate.billing.typedRef}
        formRef_isBillingAndShippingTheSame={
          locate.isBillingAndShippingTheSame.typedRef
        }
      />

      <ShippingMethod
        formRef_authorizeDelivery={
          locate.shipping.authoriseDeliveryToBeLeftWithoutSignature.typedRef
        }
      />

      <DeliveryDetailsActions />

      <DeliveryDetailsFormAutoScrolling />
    </form>
  );
};
